/**
 * Icone Complevia — stile SF Symbols (stroke, caps arrotondati).
 * Usare solo queste export in app.jsx.
 */
import React from 'react';

export const Ic = ({ d, s = 20, c = '', sw = 1.65 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={s}
    height={s}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={sw}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`cplv-icon shrink-0 ${c}`.trim()}
    aria-hidden="true"
  >
    {d}
  </svg>
);

export const IcPlus = (p) => <Ic d={<><path d="M12 5v14" /><path d="M5 12h14" /></>} {...p} />;
export const IcSearch = (p) => <Ic d={<><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>} {...p} />;
export const IcTrash = (p) => (
  <Ic
    d={
      <>
        <path d="M3 6h18" />
        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
        <path d="M10 11v6" />
        <path d="M14 11v6" />
      </>
    }
    {...p}
  />
);
export const IcEdit = (p) => (
  <Ic
    d={
      <>
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
      </>
    }
    {...p}
  />
);
export const IcCheck = (p) => <Ic d={<path d="M20 6 9 17l-5-5" />} {...p} />;
export const IcX = (p) => <Ic d={<><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>} {...p} />;
export const IcCopy = (p) => (
  <Ic d={<><rect width="14" height="14" x="8" y="8" rx="2" /><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" /></>} {...p} />
);
export const IcFile = (p) => (
  <Ic d={<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /></>} {...p} />
);
export const IcImage = (p) => (
  <Ic d={<><rect width="18" height="18" x="3" y="3" rx="2" /><circle cx="9" cy="9" r="2" /><path d="m21 15-5-5L5 21" /></>} {...p} />
);
export const IcClip = (p) => (
  <Ic
    d={
      <path d="m16 4-8.5 8.5a3 3 0 1 0 4.24 4.24L20.24 8.24a5 5 0 0 0-7.07-7.07L4.5 11.84" />
    }
    {...p}
  />
);
export const IcUsers = (p) => (
  <Ic
    d={
      <>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </>
    }
    {...p}
  />
);
export const IcHome = (p) => (
  <Ic d={<><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><path d="M9 22V12h6v10" /></>} {...p} />
);
export const IcPkg = (p) => (
  <Ic
    d={
      <>
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <path d="M3.27 6.96 12 12.01 20.73 6.96" />
        <path d="M12 22.08V12" />
      </>
    }
    {...p}
  />
);
export const IcMail = (p) => (
  <Ic d={<><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-10 6L2 7" /></>} {...p} />
);
export const IcPrint = (p) => (
  <Ic
    d={
      <>
        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
        <path d="M6 9V3h12v6" />
        <rect width="12" height="8" x="6" y="14" rx="1" />
      </>
    }
    {...p}
  />
);
export const IcSettings = (p) => (
  <Ic
    d={
      <>
        <circle cx="12" cy="12" r="3" />
        <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
      </>
    }
    {...p}
  />
);
export const IcChart = (p) => (
  <Ic d={<><path d="M18 20V10" /><path d="M12 20V4" /><path d="M6 20v-6" /></>} {...p} />
);
export const IcDl = (p) => (
  <Ic d={<><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="M7 10l5 5 5-5" /><path d="M12 15V3" /></>} {...p} />
);
export const IcUpload = (p) => (
  <Ic d={<><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="m17 8-5-5-5 5" /><path d="M12 3v12" /></>} {...p} />
);
export const IcAlert = (p) => (
  <Ic
    d={
      <>
        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
      </>
    }
    {...p}
  />
);
export const IcEye = (p) => (
  <Ic d={<><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" /><circle cx="12" cy="12" r="3" /></>} {...p} />
);
export const IcLock = (p) => (
  <Ic d={<><rect width="18" height="11" x="3" y="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></>} {...p} />
);
export const IcLogout = (p) => (
  <Ic d={<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" /></>} {...p} />
);
export const IcUser = (p) => (
  <Ic d={<><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>} {...p} />
);
export const IcGrid = (p) => (
  <Ic
    d={
      <>
        <rect width="7" height="7" x="3" y="3" rx="1.5" />
        <rect width="7" height="7" x="14" y="3" rx="1.5" />
        <rect width="7" height="7" x="14" y="14" rx="1.5" />
        <rect width="7" height="7" x="3" y="14" rx="1.5" />
      </>
    }
    {...p}
  />
);
export const IcMenu = (p) => <Ic d={<><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>} {...p} />;
export const IcChevronLeft = (p) => <Ic d={<path d="m15 18-6-6 6-6" />} {...p} />;
export const IcChevronRight = (p) => <Ic d={<path d="m9 18 6-6-6-6" />} {...p} />;
export const IcTrend = (p) => (
  <Ic d={<><path d="m3 17 6-6 4 4 8-9" /><path d="M14 7h7v7" /></>} {...p} />
);
export const IcClipboard = (p) => (
  <Ic
    d={
      <>
        <rect width="8" height="4" x="8" y="2" rx="1" />
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
        <path d="M9 12h6" />
        <path d="M9 16h6" />
      </>
    }
    {...p}
  />
);
export const IcCard = (p) => (
  <Ic d={<><rect width="20" height="14" x="2" y="5" rx="2" /><path d="M2 10h20" /><path d="M6 15h4" /></>} {...p} />
);
export const IcWrench = (p) => <Ic d={<path d="M14.7 6.3a4 4 0 0 0-5 5L4 20l-1 1 2-2 8.7-8.7a4 4 0 0 0 5-5l1 1 2.5-2.5-.5-2.5 2.5-2.5-2.5-.5L14.7 6.3z" />} {...p} />;
export const IcLayers = (p) => (
  <Ic
    d={
      <>
        <path d="m12 2 9 5-9 5-9-5 9-5z" />
        <path d="m3 12 9 5 9-5" />
        <path d="m3 17 9 5 9-5" />
      </>
    }
    {...p}
  />
);
export const IcCogStack = (p) => <IcSettings {...p} />;
export const IcDroplet = (p) => (
  <Ic d={<path d="M12 2.69l5.66 5.66a6 6 0 1 1-11.32 0z" />} {...p} />
);
export const IcCalendar = (p) => (
  <Ic
    d={
      <>
        <rect width="18" height="18" x="3" y="4" rx="2" />
        <path d="M16 2v4M8 2v4M3 10h18" />
      </>
    }
    {...p}
  />
);
export const IcSparkles = (p) => (
  <Ic
    d={
      <>
        <path d="M9.94 2 8 6.5 3.5 8.5 8 10.5 9.94 15l2-4.5 4.5-2-4.5-2L9.94 2z" />
        <path d="M18 14l-1 2-2 1 2 1 1 2 1-2 2-1-2-1-1-2z" />
      </>
    }
    {...p}
  />
);
